import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { computed, observable } from 'mobx';
import { Model, referenceMany } from 'libx';
var BillingProfile = (_class = /*#__PURE__*/function (_Model) {
  function BillingProfile() {
    var _this;
    _classCallCheck(this, BillingProfile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BillingProfile, [].concat(args));
    _initializerDefineProperty(_this, "defaultBillingMethodId", _descriptor, _this);
    _initializerDefineProperty(_this, "defaultPayoutMethodId", _descriptor2, _this);
    return _this;
  }
  _inherits(BillingProfile, _Model);
  return _createClass(BillingProfile, [{
    key: "billingMethods",
    get: function get() {
      return referenceMany(this.rootStore.billingStore.billingMethods, this.id, 'billingProfileId');
    }
  }, {
    key: "payoutMethods",
    get: function get() {
      return referenceMany(this.rootStore.billingStore.payoutMethods, this.id, 'billingProfileId');
    }
  }, {
    key: "parse",
    value: function parse(json) {
      this.rootStore.billingStore.billingMethods.set(json.billing_methods);
      this.rootStore.billingStore.payoutMethods.set(json.payout_methods);
      return {
        id: json.id,
        defaultBillingMethodId: json.default_billing_method_id,
        defaultPayoutMethodId: json.default_payout_method_id,
        userId: json.user_id,
        userPublicId: json.user_public_id,
        workspaceId: json.workspace_id,
        referralCouponCode: json.referral_coupon_code,
        referralCouponId: json.referral_coupon_id,
        teamId: json.team_id
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "defaultBillingMethodId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "defaultPayoutMethodId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "billingMethods", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "billingMethods"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payoutMethods", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payoutMethods"), _class.prototype), _class);
export { BillingProfile as default };
//# sourceMappingURL=BillingProfile.js.map
